import {Menu} from "antd";
import menus from '../../../const/menus.jsx';
import {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useMount} from "ahooks";
import menuInstance from "@/common/cacheMenuInfo.js";

import menuChangeListener_instance from '@/lib/menuChangeListener';

// Read the menu without mutating its children; resizing can remount this component.
const findTargetMenu = (list, key) => {
  for (const item of list) {
    if (item.key === key) return item;
    if (item.children) {
      const found = findTargetMenu(item.children, key);
      if (found) return found;
    }
  }
};

function MenuComponent({onMenuClick}) {

  const menusList = menus;
  const [selectKey, setSelectKey] = useState(['/']);
  const [openKeys, setOpenKeys] = useState();
  const menuInit = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();

  useMount(() => {
    initOpenKeys();
  });

  useEffect(() => {
    const key = location.pathname;

    if (findTargetMenu(menus, key)) setSelectKey([key]);

  }, [location]);

  const initOpenKeys = () => {
    if(!menuInit.current){
      menuInit.current = true;
      const key = location.pathname;
      setSelectKey([key]);
      const parentMenu = findParent(key)

      const currentMenu = findTargetMenu(menusList, key);
      menuInstance.serMenuInfo(currentMenu)

      if (parentMenu) {
        const parentKey = parentMenu.path ? parentMenu.path : parentMenu.key
        setOpenKeys([parentKey]);
      }
    }
  }


  const findParent = (key) => {
    for (const item of menusList) {
      const children = item.children;
      if (children?.length) {
        for (const item1 of children) {
          if (item1.key === key) {
            return item;
          }
        }
      }
    }
  }

  const onClick = (item) => {

    if(!menuChangeListener_instance.onPageChangeBefore(() => {
      onPageJump(item);
    })){
      onPageJump(item);
    }
  };

  const onPageJump = (item) => {

    menuChangeListener_instance.clearList();

    const {key, keyPath} = item;
    const code = item.item.props?.search?.code;
    const priCode = item.item.props?.search?.priCode;

    let currentMenu = findTargetMenu(menusList, key);
    menuInstance.serMenuInfo(currentMenu);

    setSelectKey(keyPath);
    if (key) {
      navigate({
        pathname: key,
        search: code ? `type=${code}&priCode=${priCode}` : ''
      });

      onMenuClick?.(item);
    }
  }


  return (
    <Menu
      onClick={onClick}
      defaultSelectedKeys={selectKey}
      selectedKeys={selectKey}
      openKeys={openKeys}
      mode="inline"
      theme="dark"
      items={menusList}
      onOpenChange={(openKeys) => {
        setOpenKeys(openKeys);
      }}
    />
  )
}

export default MenuComponent